import React from "react";
import { ICallToAction } from "../../models/ICallToAction";
import { IonCol, IonButton, IonIcon } from "@ionic/react";
import { heart } from "ionicons/icons";

interface CallToActionProps {
  cta: ICallToAction;
}

export const CallToAction: React.FC<CallToActionProps> = ({ cta }) => {
  return (
    <IonCol size="12" sizeMd="4" key={cta.Text}>
      {cta.Type === "donate" ? (
        <IonButton href={cta.Url} expand="block" color="danger">
          <IonIcon slot="start" icon={heart} />
          {cta.Text}
        </IonButton>
      ) : (
        <IonButton href={cta.Url} expand="block" color="secondary">
          {cta.Text}
        </IonButton>
      )}
    </IonCol>
  );
};
